import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

/**
 * Un filtro del cuadro de construcciones: botón de dos estados con su conteo.
 *
 * LO USAN LA BARRA DE HERRAMIENTAS Y EL CRUCE CON TERRENO, y se dibuja con el
 * borde `input` (#dfe0e2) y no con `border` (#ececec): sobre la franja gris de
 * la barra, el borde claro dejaba al chip casi sin contorno. Activo se invierte
 * a la tinta del diseño (#17181b), igual que el resto de los controles de dos
 * estados del cuadro.
 *
 * ES UN `<button>` CON LAS CLASES DEL DS y no un `Button`: el diseño mide 30 px
 * de alto y radio de 9 px, que no es ningún tamaño del botón del sistema.
 */
export function ChipDelCuadro({
  activo,
  rotulo,
  cantidad,
  punto,
  onClick,
}: {
  activo: boolean;
  rotulo: string;
  cantidad: number;
  /** Un punto de color antes del rótulo (el cruce con terreno). */
  punto?: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      aria-pressed={activo}
      onClick={onClick}
      className={cn(
        "focus-visible:ring-ring/50 inline-flex h-7.5 items-center gap-1.5 rounded-[0.5625rem] border-[1.5px] px-2.5 text-xs whitespace-nowrap transition-colors outline-none focus-visible:ring-[3px]",
        activo
          ? "border-foreground bg-foreground text-background font-bold"
          : "border-input bg-background text-foreground hover:bg-accent font-semibold",
      )}
    >
      {punto}
      {rotulo}
      <span
        className={cn(
          "font-mono text-[0.65625rem] font-bold",
          activo ? "text-background/70" : "text-ink-muted",
        )}
      >
        {cantidad}
      </span>
    </button>
  );
}
